import { Modal, ModalHeading, Button, DropdownButton, TextArea } from "@biteship/atom";
import Input from "./input";
import { normalizeTicketType } from "screens/tickets/helpers/mapper";
import { firstCategoryOptions, secondCategoryOptions } from "screens/tickets/helpers/constant";
import ExtraDocumentInput from "./ExtraDocumentInput";
import {
  createTicketValidator,
  isTicketMustIncludedOrderId,
} from "screens/tickets/helpers/validator";
// import { trackEvent } from "services/analytics";

export default function ModalCreateTicket(props) {
  const onImageDrop = (e) => {
    props.setInput({
      ...props.input,
      images: e,
    });
  };
  const onInputChange = (key, value1, value2) => {
    const newInput = { ...props.input };
    if (key === "type") {
      newInput.type = value1;
      newInput.firstCategoryValue = value2;
    } else if (key === "firstCategoryValue") {
      newInput.firstCategoryValue = value1;
      newInput.type = "";
    } else {
      newInput[key] = value1;
    }

    props.setInput(newInput);
  };
  const firstCategoryTitle = firstCategoryOptions.find(
    (i) => i.value === props.input.firstCategoryValue
  )?.title;
  return (
    <Modal
      show={props.show}
      className="md:max-w-3xl w-full md:px-16 md:py-8 py-4 px-8"
      onClose={props.onClose}
    >
      <ModalHeading
        title="Buat Tiket Baru"
        onClose={() => props.onClose(false)}
        className="py-2 px-0"
      />
      <div className="my-4 space-y-4">
        <Input
          onChange={(e) => onInputChange("title", e.target.value)}
          placeholder="Masukkan Judul Tiket"
          label={<div className="text-gray-900 font-bold">Judul Tiket</div>}
          inputClassName="text-gray-900"
          value={props.input.title}
        />
        <div>
          <p className={`block text-sm font-bold text-gray-900 mb-2`}>Kategori Kendala 1</p>
          <DropdownButton
            title={
              !props.input.firstCategoryValue ? (
                <div className="text-gray-700">Pilih Kategori</div>
              ) : (
                <div className="text-gray-900">{firstCategoryTitle}</div>
              )
            }
            actions={[
              firstCategoryOptions.map((i) => ({
                title: i.title,
                onClick: () => onInputChange("firstCategoryValue", i.value),
              })),
            ]}
            className="w-full"
            buttonClassName="items-center border-gray-700"
            menuClassName="w-full max-h-56"
          />
        </div>
        <div>
          <p className={`block text-sm font-bold text-gray-900 mb-2`}>Kategori Kendala 2</p>
          <DropdownButton
            title={
              !props.input.type ? (
                <div className="text-gray-700">Pilih Kategori</div>
              ) : (
                <div className="text-gray-900">
                  {normalizeTicketType(props.input.type).secondCategory}
                </div>
              )
            }
            actions={[
              secondCategoryOptions(props.input.firstCategoryValue).map((i) => ({
                title: i.title,
                onClick: () => onInputChange("type", i.value, i.firstCategoryValue),
              })),
            ]}
            className="w-full mb-1"
            buttonClassName="items-center border-gray-700"
            menuClassName="w-full max-h-56"
          />
          <a
            href="https://help.biteship.com/hc/id/articles/23958148526873-Panduan-Pemilihan-Kategori-Tiket-Bantuan"
            target="_blank"
            className="text-xs text-primary hover:underline cursor-pointer"
            // onClick={() => trackEvent("Ticket ComplainGuidance")}
          >
            Panduan Kategori
          </a>
        </div>
        {isTicketMustIncludedOrderId(firstCategoryTitle) && (
          <Input
            onChange={(e) => onInputChange("orderIds", e.target.value)}
            placeholder="Masukkan Nomor Resi"
            label={<div className="text-gray-900 font-bold">Nomor Resi</div>}
            inputClassName="text-gray-900"
            value={props.input.orderIds}
          />
        )}
        <TextArea
          onChange={(e) => onInputChange("description", e.target.value)}
          placeholder="Tuliskan Detail Kendala Anda Disini"
          rows={4}
          className="text-gray-900 placeholder-gray-700"
          label={<div className="text-gray-900 font-bold mb-2">Detail Kendala</div>}
          value={props.input.description}
        />
        <div>
          <p className={`block text-sm font-bold text-gray-900 mb-2`}>
            Dokumen Pendukung (Opsional)
          </p>
          <ExtraDocumentInput
            onDrop={onImageDrop}
            info="Masukkan foto invoice barang"
            maxFiles={3}
            maxSize={5000000}
            images={props.input.images}
            onClickImage={(idx) => {
              props.setActiveImage(idx);
              props.setModalType("image");
            }}
          />
        </div>
      </div>
      <Button
        title={
          <div className={`font-bold ${!createTicketValidator(props.input) && "text-neutral-60"}`}>
            Buat Tiket
          </div>
        }
        className={`w-full my-2 justify-center ${
          !createTicketValidator(props.input) && "bg-neutral-40 hover:bg-neutral-40"
        }`}
        onClick={() => props.onSubmit()}
        loading={props.submitLoading}
        loadingTitle={<div className="font-bold ml-2">Membuat Tiket</div>}
        disabled={!createTicketValidator(props.input)}
      />
    </Modal>
  );
}
